import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BaseApiTemplateService} from '../../shared';
import {Core2Config} from '../../shared';
import { HrClaimApprovalSettingContainerModel} from '../../../../../../models';


@Injectable({
  providedIn: 'root'
})
export class HrClaimApprovalSettingService extends BaseApiTemplateService<HrClaimApprovalSettingContainerModel> {
  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.HR_PREFIX + 'account-entitlement-approval-settings/backoffice-ep';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.HR_PREFIX + 'account-entitlement-approval-settings/backoffice-ep';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.HR_PREFIX + 'account-entitlement-approval-settings/backoffice-ep';
    this.httpClient = http;
  }

}


